import http from "../../http";

const customer = {
    getByMobileOrNickname(param){
        return http.get("/gateway/apps/basic/api/base/uc/getByMobileOrNickname", param);
    }
}
export default customer